import { jsx as _jsx } from "react/jsx-runtime";
import { TranslatableString } from '@rjsf/utils';
import { Button } from '@chakra-ui/react';
import { AddIcon } from '@chakra-ui/icons';
export default function AddButton({ uiSchema, registry, ...props }) {
    const { translateString } = registry;
    return (_jsx(Button, { leftIcon: _jsx(AddIcon, {}), ...props, children: translateString(TranslatableString.AddItemButton) }));
}
//# sourceMappingURL=AddButton.js.map